// English (en)
export default {
  SelfService: {
    Titles: {
      basicInfo: "So happy you're here!",
      patientVerification: 'Verify Your Phone Number',
      connectToCare: 'Connect to Care',
    },
    IntroText: {
      basicInfo: "Let's get started and connect you to care.",
      patientInfo: "Please provide your residential address and other onboarding details to be matched with a provider practicing in your state."
    },
    Fields: {
      legalFirstName: 'Legal First Name',
      legalLastName: 'Legal Last Name',
      mobilePhone: 'Mobile Phone Number',
      pronouns: 'Pronouns',
      genderIdentity: 'Gender Identity',
      legalSex: 'Sex listed on Insurance',
      address: 'Address Line 1'
    },
    legalNameNotice: "Enter your name exactly as it appears on your government-issued ID (e.g., Driver's License or Passport).",
    mobilePhoneNotice: 'Used for all appointment reminders and session links. Please provide your primary mobile number (no landlines or VoIP/Google Voice). By providing my phone number, I authorize Valera Health and its affiliates to contact me by calling or by automated SMS text message.',
    whyNeed: "Why does Valera Health need this?",
    whyNeedTooltip: 'Insurance companies require verification that the patient will receive care from the state in which the provider is licensed and credentialed.',
    whatIsYourEmail: 'What is your email address?',
    addGenderIdentity: 'Add preferred name, gender identity and pronouns (optional)',
    uploadId: 'Upload Government Issued ID',
    thisIsOptional: 'This is optional, but recommended.',
    sexListedOnInsurance: 'For insurance and billing purposes, what sex is listed on your insurance policy?'
  },
}
